import { upgradeModule } from '@/store/upgrade/module'
import { router } from '@/router'
import { mobileModule } from '@/store/mobile/module'

const getIsShowingUpgradeModal = () => {
    const route = router.currentRoute.value
    if (!route.matched.some(r => r.meta?.requiresAuth)) {
        return false
    }

    return upgradeModule.state.isShowingUpgradeModal
}

const getPaymentPlatform = () => {
    return mobileModule.getters.getPlatform() || 'Web'
}

export default {
    getIsShowingUpgradeModal,
    getPaymentPlatform,
}
